import { LinkOverlay } from 'front-end/src/components'
import React, { FC } from 'react'

import { linkBuilder } from '../../../../../../shared/linkBuilder'
import UserAvatar from '../user-avatar/UserAvatar'

interface IProps {
  user: {
    id: number
    display_name: string | null | undefined
    image_url: string | null
  }
  size?: 'small' | 'normal'
}

export const LinkableUserAvatar: FC<IProps> = ({ user, size = 'normal' }) => {
  return (
    <LinkOverlay to={linkBuilder.userDetail(user.id)}>
      <UserAvatar user={user} size={size} />
    </LinkOverlay>
  )
}
